var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",staticStyle:{"min-width":"1400px"}},[_c('HomeHeader'),_c('TopicCongress'),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }